import {SvgIcon, SvgIconProps} from "@material-ui/core";
import * as React from 'react';

class ArchiveIcon extends React.Component<SvgIconProps> {
    public render() {
        return (
            <SvgIcon {...this.props} style={{fill: 'none'}} viewBox="0 0 11 11" fill="none" stroke="none">
                <path d="M9.47761 1.48138H1.52239C1.23388 1.48138 1 1.71526 1 2.00377V3.23994C1 3.52844 1.23388 3.76232 1.52239 3.76232H9.47761C9.76612 3.76232 10 3.52844 10 3.23994V2.00377C10 1.71526 9.76612 1.48138 9.47761 1.48138Z" stroke="#1D1D1B" strokeMiterlimit="10"/>
                <path d="M8.7337 3.87454V8.99623C8.7337 9.28404 8.49913 9.51861 8.21132 9.51861H2.78887C2.50105 9.51861 2.26648 9.28404 2.26648 8.99623V3.87454" stroke="#1D1D1B" strokeMiterlimit="10"/>
                <path d="M4.30115 5.45328H6.69865" stroke="#1D1D1B" strokeMiterlimit="10" strokeLinecap="round"/>
            </SvgIcon>
        );
    }
}

export default ArchiveIcon;



// WEBPACK FOOTER //
// ./src/components/svg/archiveIcon.tsx